import { render, staticRenderFns } from "./Mensageria.vue?vue&type=template&id=169235f2"
import script from "./Mensageria.vue?vue&type=script&lang=js"
export * from "./Mensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports